import { Component, input, output } from '@angular/core';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { MessageThread } from '../../message.api.service';
import { MessageSummaryComponent } from '../message-summary/message-summary.component';
import { MessageTypePipe } from '../../message.pipe';
import { FlIconComponent } from '@common';

/**
 * 系统消息入口（左栏 type===0 单条）
 *
 * 与任务聚合条目（fl-task-message-item）并列：点击进右栏通知列表，无手风琴展开区。
 * 展示 类型图标(未读角标) + 标题 + 最后一条消息摘要。
 */
@Component({
  selector: 'fl-system-message-item',
  standalone: true,
  host: { class: 'block' },
  imports: [NzBadgeModule, MessageTypePipe, MessageSummaryComponent, FlIconComponent],
  template: `
    <div
      class="relative flex items-center gap-[12px] p-2 rounded-[6px] cursor-pointer transition-colors hover:bg-neutral-n7"
      [class.bg-primary-b7]="active()"
      (click)="toggle.emit()"
    >
      <nz-badge [nzCount]="unreadCount()" [nzShowZero]="false" [nzOffset]="[-8, 2]">
        <div
          class="relative shrink-0 size-[32px] rounded-full flex items-center justify-center border"
          [class]="(thread().type | messageType).colorClass"
        >
          <lib-fl-icon name="icon-xitongxiaoxi" size="32"></lib-fl-icon>
        </div>
      </nz-badge>
      <div class="flex-1 min-w-0">
        <div class="text-[15px] font-medium leading-[1.4] truncate">{{ thread().title }}</div>
        <div class="text-[13px] leading-[20px] mt-1/2 truncate text-neutral-n3">
          <fl-message-summary [summary]="thread().lastMessage"></fl-message-summary>
        </div>
      </div>
    </div>
  `,
})
export class SystemMessageItemComponent {
  /** 系统消息 thread */
  readonly thread = input.required<MessageThread>();

  /** 是否选中（高亮） */
  readonly active = input(false);

  /** 系统消息未读角标数 */
  readonly unreadCount = input(0);

  /** 点击进入右栏通知列表 */
  readonly toggle = output<void>();
}
